const colors = {
  primary: '#21361e',
  secondary: '#34585f',
  backgroundhero: '#fcf8ef',
  greentext: '#173c33',
  greenbutton: '#427e5e',
  button: '#ede1c4',
  bgbutton: '#ece1c4',
  font: 'Raleway',
  font2: 'Raleway',
  // ── Palette premium HTML ──
  or: '#c8a84b',
  orClair: '#e8c96b',
  beige: '#f5ede0',
  beigeFonce: '#e8d5b8',
  marron: '#6b4c2a',
  vertOlive: '#3a5a2e',
  vertClair: '#5a8a45',
  heroBg: '#0e1a0a',
  blanc: '#faf8f4',
  texte: '#2a2018',
  texteLeger: '#6b5a42',
}

export default colors
